import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "@/components/ui/card";

export default function Searching() {
    return (
        <div className="space-y-6">
            <h2 className="text-3xl font-bold tracking-tight">
                Searching & Filtering
            </h2>
            <div className="grid gap-6">
                <Card>
                    <CardHeader>
                        <CardTitle>Search Products</CardTitle>
                        <CardDescription>
                            Find products quickly and efficiently
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <p className="text-sm text-muted-foreground">
                            The search functionality allows you to quickly find
                            products by searching across multiple fields
                            simultaneously.
                        </p>
                        <div className="rounded-md bg-muted p-4">
                            <p className="text-sm">Search across:</p>
                            <ul className="mt-2 list-disc pl-4 text-sm space-y-2">
                                <li>Product names</li>
                                <li>Variant names</li>
                                <li>SKU numbers</li>
                            </ul>
                        </div>
                    </CardContent>
                </Card>

                <Card>
                    <CardHeader>
                        <CardTitle>Filter Options</CardTitle>
                        <CardDescription>
                            Refine your product view
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <p className="text-sm text-muted-foreground">
                            Use multiple filter criteria to narrow down your
                            product list and focus on specific items.
                        </p>
                        <div className="rounded-md bg-muted p-4">
                            <p className="text-sm">Available filters:</p>
                            <ul className="mt-2 list-disc pl-4 text-sm space-y-2">
                                <li>
                                    Categories - Filter by product categories
                                </li>
                                <li>Product Types - Filter by product type</li>
                                <li>Tags - Filter by one or more tags</li>
                                <li>Status - Filter by optimization status</li>
                                <li>
                                    Price Range - Filter by minimum and maximum
                                    price
                                </li>
                            </ul>
                        </div>
                    </CardContent>
                </Card>

                <Card>
                    <CardHeader>
                        <CardTitle>Price Range Filter</CardTitle>
                        <CardDescription>
                            Filter products by price
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <p className="text-sm text-muted-foreground">
                            Use the price range slider to filter products within
                            specific price brackets. The range automatically
                            adjusts based on your product catalog.
                        </p>
                        <div className="rounded-md bg-muted p-4">
                            <p className="text-sm">Price filter features:</p>
                            <ul className="mt-2 list-disc pl-4 text-sm space-y-2">
                                <li>Interactive price range slider</li>
                                <li>Dynamic range based on product prices</li>
                                <li>Real-time filtering as you adjust</li>
                                <li>Clear price boundaries display</li>
                            </ul>
                        </div>
                    </CardContent>
                </Card>

                <Card>
                    <CardHeader>
                        <CardTitle>Managing Filters</CardTitle>
                        <CardDescription>
                            Working with multiple filters
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <p className="text-sm text-muted-foreground">
                            Combine multiple filters to create precise product
                            views. All filters can be used simultaneously, and
                            you can easily reset them when needed.
                        </p>
                        <div className="rounded-md bg-muted p-4">
                            <p className="text-sm">Filter management:</p>
                            <ul className="mt-2 list-disc pl-4 text-sm space-y-2">
                                <li>Combine multiple filter criteria</li>
                                <li>Reset all filters with one click</li>
                                <li>Filter counts show active filters</li>
                                <li>
                                    Persistent filter settings across sessions
                                </li>
                            </ul>
                        </div>
                    </CardContent>
                </Card>

                <Card>
                    <CardHeader>
                        <CardTitle>Table Features</CardTitle>
                        <CardDescription>
                            Additional product management tools
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <p className="text-sm text-muted-foreground">
                            The product table includes additional features to
                            help you manage and organize your products
                            effectively.
                        </p>
                        <div className="rounded-md bg-muted p-4">
                            <p className="text-sm">Table features:</p>
                            <ul className="mt-2 list-disc pl-4 text-sm space-y-2">
                                <li>Sortable columns for all fields</li>
                                <li>Customizable page size</li>
                                <li>Pagination controls</li>
                                <li>Bulk selection options</li>
                                <li>Column visibility toggle</li>
                            </ul>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
